import React from 'react';
import { Badge } from '../ui';

// Shikoyat holati (faqat ko'rsatish): reviewed true → "Ko'rib chiqilgan", false → "Yangi", boshqa → kelgan qiymat.
function ComplaintStatus({ reviewed }) {
    if (reviewed === true) return <Badge variant="success" size="sm" dot>Ko'rib chiqilgan</Badge>;
    if (reviewed === false) return <Badge variant="warning" size="sm" dot>Yangi</Badge>;
    return (
        <Badge variant="neutral" size="sm">
            {reviewed === undefined || reviewed === null ? '—' : String(reviewed)}
        </Badge>
    );
}

export default ComplaintStatus;
